<!--我的需求  myRequire-->
<template>

	<div class="request-content">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<van-cell-group class="request-item" v-for="(item,index) in list" :key="index">
					<van-cell title="单位名称" :value="item.entName" />
					<van-cell title="融资金额(万元)" :value="item.reqAmount" />
					<van-cell title="融资期限" :value="item.reqLimit" />
					<van-cell title="是否续贷" :value="getRenewType(item.renewType)" />
					<van-cell title="担保方式" :value="item.guaranteeType" />
					<van-cell title="贷款用途" :value="item.loanUse" />
					<van-cell title="联系电话" :value="item.applyPhone" />
					<van-cell title="发布日期" :value="item.createdDate" />
					<div class="btn-group">
						<van-button class="request-item-btn" type="primary" size="small" @click="gotoModifyRequire(item.reqAmount,item.reqId,item.reqLimit,item.applyPhone,item.loanUse,item.renewType,item.guaranteeType)">修改需求</van-button>
						<van-button class="request-item-btn" type="info" size="small" @click="gotoDelet(item.reqId)">删除需求</van-button>
					</div>
				</van-cell-group>
			</van-list>
		</van-pull-refresh>

	</div>

</template>

<script>
	import Vue from 'vue';
	import {
		Cell,
		CellGroup,
		Dialog,
		List,
		PullRefresh
	} from "vant";
	import {
		SSHJRCRQ001,
		SSHJRCRI002,
	} from "../../../api/user";
	import checkAJB from "../../../utils/checkAlipayJSBridge.js";
	import {
		mapGetters
	} from "vuex";
	Vue.use(List);
	Vue.use(PullRefresh);
	Vue.use(Cell);
	Vue.use(CellGroup);
	Vue.use(Dialog);
	export default {
		data() {
				return {
					list: [],
					loading: false,
					finished: false,
					refreshing: false,
					pageNum: 1,
					// sessionId: "",
					isLastPage: false,
					reqId: "", //需求id
					corpId: ""
				};
			},
			async created() {
				console.log("进入");
				// let result = await checkAJB.getUserInfo();
				// let resultSession = await checkAJB.getLocalData("sessionId");
				// this.sessionId = resultSession.data;
				// this.sessionId = this.sessionId.replace('"', "").replace('"', ""); //去掉多余双引号
				let res = await this.$store.dispatch("user/getUserInfo");
				this.corpId = res.userInfo.userId;
				console.log(res.userInfo.userId, "res");
			},
			computed: {
				...mapGetters(["sessionId", "userInfo", "phoneNum"])
			},
//			filters:{
//			    formatNumber:function(value){
//			      return  ((value * 1)/10000).toFixed(0);
//			    }
//			  },
			methods: {
				onLoad() {
					// 异步更新数据
					// setTimeout 仅做示例，真实场景中一般为 ajax 请求
					setTimeout(() => {
						if(this.refreshing) {
							this.list = [];
							this.pageNum = 1;
							this.refreshing = false;
						}
						this.MyRequirement();

					}, 1000);
				},
				onRefresh() {
					this.finished = false;
					// 重新加载数据
					// 将 loading 设置为 true，表示处于加载状态
					this.loading = true;
					this.onLoad();
				},
				MyRequirement() {
					var that = this;
					SSHJRCRQ001({
							data: {
								sessionId: this.sessionId,
								pageNum: this.pageNum,
								pageSize: "6"
							}
						})
						.then(res => {
							console.log("001");
							console.log(res);
							this.paramPageInfo = res.data.paramPageInfo;
							this.isLastPage = this.paramPageInfo.isLastPage; //最后一页
							let pageList = that.paramPageInfo.list;
							for(let i = 0; i < pageList.length; i++) {
								this.list.push(pageList[i])
							}
							this.pageNum = this.pageNum + 1;
							this.loading = false;
							if(!this.isLastPage) {
								//是否是最后一页 ture表示最后一页
								this.finished = false; //数据全部加载完成
							} else {
								this.finished = true; //数据全部加载完成
								this.refreshing = false;
							}
						})
						.catch(err => {
							this.$toast(err.respMsg);
						});
				},
				gotoDelet(reqId) {
					Dialog.confirm({
						title: '确定删除该需求么？'
					}).then(() => {
						SSHJRCRI002({
							data: {
								sessionId: this.sessionId,
								reqId: reqId
							}
						}).then(res => {
							if(res.resCode === "0000") {
								this.$toast("删除成功");
							} else {
								this.$toast("删除失败，"+res.resDesc);
							}
							
							this.refreshing=true;
							this.onLoad();
						}).catch(err => {
							console.log(err);
							this.$toast("删除失败");
						});
					}).catch(() => {});
				},
				gotoModifyRequire(reqAmount, reqId, reqLimit, applyPhone, loanUse, renewType, guaranteeType) {
					this.$router.push({
						name: "ModifyRequire",
						params: {
							sessionId: this.sessionId,
							corpId: this.corpId,
							reqAmount: reqAmount,
							reqId: reqId,
							reqLimit: reqLimit,
							applyPhone: applyPhone,
							loanUse: loanUse,
							renewType: renewType,
							guaranteeType: guaranteeType
						}
					});
				},
				getRenewType(renewType) {
					if(renewType === "yes") {
						return "是";
					} else if(renewType === "no") {
						return "否";
					} else {
						return renewType;
					}

				}
			}
	};
</script>

<style lang="less" scoped>
	.request-content {
		height:100%;
		width:100%;
		position:fixed;
		background-color:rgba(241,242,243,1);
		overflow-y: auto;
		.request-item {
			box-sizing: border-box;
			width: 100%;
			background: rgba(255, 255, 255, 1);
			border-radius: 10px;
			margin-top: 10px;
			padding: 10px;
			margin-bottom: 15px;
			.btn-group {
				text-align: right;
				.request-item-btn {
					margin: 6px 20px;
				}
			}
		}
	}
</style>